
/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang( 'colortext', 'ro', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
} );



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/colortext/lang/ro.js